import { render, staticRenderFns } from "./psOutHisList.vue?vue&type=template&id=2b9aa9e2&scoped=true"
import script from "./psOutHisList.vue?vue&type=script&lang=js"
export * from "./psOutHisList.vue?vue&type=script&lang=js"
import style0 from "./psOutHisList.vue?vue&type=style&index=0&id=2b9aa9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9aa9e2",
  null
  
)

export default component.exports